import { Component } from '@angular/core'

@Component({
  selector: 'cover-cancellation-dialog',
  templateUrl: './cancellation-dialog.component.html',
  styleUrls: ['./cancellation-dialog.component.scss'],
})
export class CancellationDialogComponent {
  constructor() {}
}
